import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
declare var $;

@Injectable()
export class LiquidacionCapturaService {

  private service_url: string;
  public modulo_url: string;
  public api_url: string;
  constructor( private http: Http,
               private constantsServices: ConstantsService,
               private authService: AutenticacionService,
               private validatorService: ValidatorService,
               private errorService: ErrorsService) {
    this.api_url = this.constantsServices.apiURL;
    this.modulo_url = '/liquidacion/captura';
    this.service_url = this.api_url + this.modulo_url;
  }

  public getDefaultSchedule() {
    return {
      'obras': {},
      'proveedores': {},
      'fechaLiquidacion' : ''
    };
  }

  public getObratoSelect() {
    return this.http.get(this.service_url+ '/obras?select=true', this.authService.getAuthHeaders());
  }

  public createLiquidaciones(idObra, fecha, desdeMovimientos) {
    const body = {
          'idObras' : idObra,
          'fechaLiquidacion': fecha,
          'desdeMovimientos': desdeMovimientos};
    return this.http.post(this.service_url, body, this.authService.getAuthHeaders());
  }

  public sendLiquidacion(idLiquidacion) {
    const data = {
      'idLiquidacion': idLiquidacion
    };
    return this.http.put(this.service_url + '/revision', data, this.authService.getAuthHeaders());
  }

  public saveFondo(data) {
    return this.http.put(this.service_url + '/fondo', data, this.authService.getAuthHeaders());
  }

  public getLiquidaciones(idObra) {
    return this.http.get(this.service_url + '?idObras='+idObra, this.authService.getAuthHeaders());
  }

  public getLiquidacionesFilter(obra?,fecha?) {
    return this.http.get(this.service_url + '?search='+obra+'&fecha='+fecha, this.authService.getAuthHeaders());
  }

  public getLiquidacionByID(idLiquidacion) {
    return this.http.get(this.service_url + '/informacion?idLiquidacion=' + idLiquidacion, this.authService.getAuthHeaders());
  }

  public getFechaActual () {
    return this.http.get(this.service_url + '/movimientos/fecha', this.authService.getAuthHeaders());
  }

  public deleteLiquidacion(id) {
    return this.http.delete(this.service_url + '?id=' + id, this.authService.getAuthHeaders());
  }

  public writePermission() {
    return this.authService.hasPermission(8, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public validateFondo(data){
    console.log("validating... ", data);
    
    let error = [];

    // validacion de aportaciones
    if (!this.validatorService.required(data["aportaciones"])) {
      error['aportaciones'] = this.errorService.required;
    }else if(!this.validatorService.numeric(data["aportaciones"])){
      error["aportaciones"] = this.errorService.numeric;
    }

    // validacion de retiros
    if (!this.validatorService.required(data["retiros"])) {
      error['retiros'] = this.errorService.required;
    }else if(!this.validatorService.numeric(data["retiros"])){
      error["retiros"] = this.errorService.numeric;
    }
    
    return error;
  }

}


// WEBPACK FOOTER //
// ./src/app/services/liquidacion-captura.service.ts